import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

import styles from './FormAuthorComplete.module.css';

import { BiArrowBack } from 'react-icons/bi';
import Title from '../../components/Title';
import InputForm from '../../components/InputForm';
import Button from '../../components/Button';

export default function FormAuthorComplete() {
  const token = localStorage.getItem('accessToken');
  const navigate = useNavigate();
  const [authorId, setAuthorId] = useState(null);
  const [author, setAuthor] = useState({
    id: null,
    endereco: '',
    telefone: '',
    cpf: '',
  });

  useEffect(() => {
    if(!token) return;
    try {
      const decodedToken = jwtDecode(token);
      setAuthorId(decodedToken.id);
    } catch (error) {
      console.error('Erro ao decodificar token', error);
    }
  }, [token]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      let newValues = [...author[name]];
      if (checked) {
        newValues.push(value);
      } else {
        newValues = newValues.filter((item) => item !== value);
      }
      setAuthor({
        ...author,
        [name]: newValues
      });
    } else {
      let newValue = value;

      if (name === 'cpf') newValue = formatCpf(value);
      if (name === 'telefone') newValue = formatCelular(value);

      setAuthor({
        ...author,
        [name]: newValue
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const dadosParaEnvio = {
      id: authorId,
      endereco: author.endereco,
      telefone: author.telefone.replace(/\D/g, ''),
      cpf: apenasNumeros(author.cpf)
    };

    axios.post('https://back-cultura-sje-production.up.railway.app/complete-info-author', dadosParaEnvio, {
      headers: {}
    })
      .then(() => {
        setAuthor({
          endereco: '',
          telefone: '',
          cpf: '',
        });

        alert('Informações adicionadas com sucesso!');
      })
      .catch((error) => {
        console.error('Erro no envio do formulário', error);

        if (error.response && error.response.data && error.response.data.message) {
          const mensagem = error.response.data.message;

          if (mensagem === 'CPF não é válido. Por favor, verifique.') {
            alert('CPF não é válido. Por favor, verifique.');
          }
        } else {
          alert('Erro inesperado ao cadastrar. Tente novamente mais tarde.');
        }
      });
    };

    function apenasNumeros(value) {
      return value.replace(/\D/g, '');
    }

    function formatCpf(value) {
      value = apenasNumeros(value).slice(0, 11);
      value = value.replace(/^(\d{3})(\d)/, '$1.$2');
      value = value.replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3');
      value = value.replace(/\.(\d{3})(\d)/, '.$1-$2');
      return value;
    }

    function formatCelular(value) {
      value = value.replace(/\D/g, '');
      value = value.slice(0, 11); 
      value = value.replace(/^(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d{5})(\d)/, '$1-$2');
      return value;
    }

    const handleGoBack = () => {
      navigate('/autores/painel');
    };
      
  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <Title color='var(--brown-300)'>Completar perfil</Title>
        <button onClick={handleGoBack} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <BiArrowBack size={24} />
          Voltar
        </button>
        <form onSubmit={handleSubmit} className={styles.formContainer}>
          <InputForm 
            mode='input'
            type='text'
            name='endereco'
            title='Endereço'
            placeholder='Digite seu endereço'
            value={author.endereco}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='tel'
            name='telefone'
            title='Telefone'
            placeholder='Digite seu número de celular'
            value={author.telefone}
            onChange={handleChange}
          />
          <InputForm 
            mode='input'
            type='text'
            name='cpf'
            title='CPF'
            placeholder='Digite seu CPF'
            value={author.cpf}
            onChange={handleChange}
          />
          <div className={styles.button}>
            <Button>Enviar</Button>
          </div>
        </form>
      </div>
    </main>
  )
}
